var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"confirm-action-pane\"\u003E\u003Cp class=\"confirm-action-pane__message\" data-bind=\"html: message\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;